import balle_perdue from '../../Images/placements/balle_perdue_1.jpg';
import berkley_fishing from '../../Images/placements/berkley_fishing.jpeg';
import kissingbooth from '../../Images/placements/kissingbooth_1.jpg';
import love_victor from '../../Images/placements/love_victor_1.jpg';
import loveisland from '../../Images/placements/loveisland_2.jpeg';
import lucifer from '../../Images/placements/lucifer_1.jpg';
import queen_apes from '../../Images/placements/queen_apes.jpeg';
import sellingsunset from '../../Images/placements/sellingsunset_1.jpg';
import sellingtheoc from '../../Images/placements/sellingtheoc.jpeg';
import tomorrowland from '../../Images/placements/tomorrowland.jpeg';
import ugly_stick from '../../Images/placements/ugly_stick.jpeg';
import honda_logo from '../../Images/placements/honda_logo.png';
import closure from '../../Images/placements/closure.jpg';
import hername from '../../Images/placements/hername.png';
import dontstopbeleiving from '../../Images/placements/dontstopbeleiving.jpeg';
import drunkentruth from '../../Images/placements/drunkentruth.jpeg';
import akon from '../../Images/collaborators/akon.jpeg';

import bella_perdue_song from '../../Audio/placements/bella_perdue.m4a';
// import berkley_fish_clip from '../../Audio/placements/berkley_fish.mp4';
// import honda_clip from '../../Audio/placements/honda.mp4';
import kissingbooth_song from '../../Audio/placements/kissingbooth.mp3';
import love_victor_song from '../../Audio/placements/love_victor.mp3';
import loveisland_song from '../../Audio/placements/loveisland.mp3';
import lucifer_song from '../../Audio/placements/lucifer.mp3';
import queen_apes_song from '../../Audio/placements/queen_apes.mp3';
import sellingsunset_song from '../../Audio/placements/sellingsunset.m4a';
import sellingtheoc_song from '../../Audio/placements/sellingtheoc.m4a';
// import ugly_stick_clip from '../../Audio/placements/ugly_stick.mp4';
import closure_song from '../../Audio/placements/Closure.mp3';
import hername_song from '../../Audio/placements/hername.mp3';
import dontstopbeleiving_song from '../../Audio/placements/dontstopbeleiving.mp3';
import drunkentruth_song from '../../Audio/placements/drunkentruth.mp3';
// import tomorrowland_clip from '../../Audio/placements/tomorrowland_clip.mp4';
import tomorrowland_song from '../../Audio/placements/tomorrowland.mp3';
import allmylife from '../../Audio/placements/allmylife.mp3';

const PlacementData = [
	{
		id: 0,
		name: 'Love Island',
		info: ['Love Island Song Placement','Peacock','Bleeding Fingers'],
		thumbnail: loveisland,
		thumbPos: {t:0,l:0,size:1},
		brands: ['peacock','bleeding_fingers'],
		videos: [],
		songs: [{name:'Andy Marsh: You & I',audio:loveisland_song}],
	},
	{
		id: 12,
		name: 'Steve Void: Closure (feat. Andy Marsh)',
		info: ['Strange Fruits','Artist','Songwriter'],
		thumbnail: closure,
		thumbPos: {t:0,l:0,size:1.26},
		brands: ['strange_fruits'],
		videos: [],
		songs: [{name:'Steve Void: Closure (feat. Andy Marsh)',audio:closure_song}],
		spotify: '15 million',
	},
	{
		id: 1,
		name: 'Kissing Booth 2',
		info: ['Kissing Booth 2','Netflix'],
		thumbnail: kissingbooth,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [{name:`Andy Marsh: You're My Air`,audio:kissingbooth_song}],
	},
	{
		id: 6,
		name: 'Love, Victor',
		info: ['Love, Victor','Hulu',],
		thumbnail: love_victor,
		thumbPos: {t:0,l:0,size:1.01},
		brands: ['hulu'],
		videos: [],
		songs: [{name:'L.O.U.D, Kali J: Bum Bum',audio:love_victor_song}],
	},
	{
		id: 2,
		name: 'Selling The OC ',
		info: ['Selling The OC ','Netflix',],
		thumbnail: sellingtheoc,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [{name:'Andy Marsh: Live It Up',audio:sellingtheoc_song}],
	},
	{
		id: 9,
		name: 'Honda Civic (Spec)',
		info: ['Honda Civic National Advertisement (SPEC)','Honda','Mophonics'],
		thumbnail: honda_logo,
		thumbPos: {t:0,l:0,size:1},
		brands: ['honda'],
		// videos: [{name:'Honda Civic National Advertisement',video:honda_clip}],
		videos: [{name:'Honda Civic National Advertisement',spanClass:'wistia_embed wistia_async_ogpuwgfjq1 popover=true popoverAnimateThumbnail=true'}],
		songs: [],
	},
	{
		id: 3,
		name: 'Selling Sunset',
		info: ['Selling Sunset','Netflix',],
		thumbnail: sellingsunset,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [{name:'Andy Marsh: Do My Thang',audio:sellingsunset_song}],
	},
	{
		id: 4,
		name: 'Balle Perdue 2 Trailer',
		info: ['Balle Perdue 2','Netflix',],
		thumbnail: balle_perdue,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [{name:'Andy Marsh: Ready For War',audio:bella_perdue_song}],
	},
	{
		id: 5,
		name: 'Lucifer',
		info: ['Lucifer','Netflix',],
		thumbnail: lucifer,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [{name:'Andy Marsh: The Future',audio:lucifer_song}],
	},
	{
		id: 7,
		name: 'Berkley Fishing',
		info: ['Berkley Fishing Holiday Advertisement','Pure Fishing','Inc / 37 Laines LLC','Composer'],
		thumbnail: berkley_fishing,
		thumbPos: {t:0,l:0,size:1},
		brands: ['pure_fishing'],
		// videos: [{name:'Berkley Fishing Holiday Advertisement',video:berkley_fish_clip}],
		videos: [{name:'Berkley Fishing Holiday Advertisement',spanClass:'wistia_embed wistia_async_thqldf3vvm popover=true popoverAnimateThumbnail=true'}],
		songs: [],
	},
	{
		id: 10,
		name: 'Queen Apes (NFT)',
		info: ['Queen Apes NFT Startup','Kali J','Dub Killer','Andy Marsh'],
		thumbnail: queen_apes,
		thumbPos: {t:0,l:0,size:1},
		brands: [],
		videos: [],
		songs: [{name:'L.O.U.D.: Back Again',audio:queen_apes_song}],
	},
	{
		id: 13,
		name: 'Magnace, LuxLyfe, Andy Marsh: Her Name',
		info: ['Strange Fruits','Artist','Songwriter'],
		thumbnail: hername,
		thumbPos: {t:0,l:0,size:1.26},
		brands: ['strange_fruits'],
		videos: [],
		songs: [{name:'Magnace, LuxLyfe, Andy Marsh: Her Name',audio:hername_song}],
		spotify: '4 million',
	},
	{
		id: 14,
		name: 'Steve Void: Drunken Truth (feat. Andy Marsh)',
		info: ['Strange Fruits','Artist','Songwriter'],
		thumbnail: drunkentruth,
		thumbPos: {t:0,l:0,size:1.26},
		brands: ['strange_fruits'],
		videos: [],
		songs: [{name:'Steve Void: Drunken Truth (feat. Andy Marsh)',audio:drunkentruth_song}],
		spotify: '1.5 million',
	},
	{
		id: 8,
		name: 'Ugly Stick',
		info: ['Ugly Stick Youtube Sketch Series','Pure Fishing','Inc / 37 Laines LLC','Composer'],
		thumbnail: ugly_stick,
		thumbPos: {t:0,l:0,size:1},
		brands: ['pure_fishing'],
		// videos: [{name:'Ugly Stick Youtube Sketch Series',video:ugly_stick_clip}],
		videos: [{name:'Ugly Stick Youtube Sketch Series',spanClass:'wistia_embed wistia_async_bvq1oteulh popover=true popoverAnimateThumbnail=true'}],
		songs: [],
	},
	{
		id: 15,
		name: `Steve Void: Don'tStop Believin' (feat. Andy Marsh & DMNDS)`,
		info: ['Strange Fruits','Artist','Songwriter'],
		thumbnail: dontstopbeleiving,
		thumbPos: {t:0,l:0,size:1},
		brands: ['strange_fruits'],
		videos: [],
		songs: [{name:`Steve Void: Don'tStop Believin' (feat. Andy Marsh & DMNDS)`,audio:dontstopbeleiving_song}],
		spotify: '2 million',
	},
	{
		id: 11,
		name: 'Tomorrowland 2015',
		info: ['Dimitri Vegas & Like Mike "Tales Of Tomorrow"','Songwriter',],
		thumbnail: tomorrowland,
		thumbPos: {t:0,l:0,size:1.5},
		brands: ['tomorrow_land'],
		// videos: [{name:'Dimitri Vegas & Like Mike vs Fedde Le Grand - Tales Of Tomorrow (feat. Julian Perretta)',video:tomorrowland_clip}],
		videos: [{name:'Dimitri Vegas & Like Mike "Tales Of Tomorrow"',spanClass:'wistia_embed wistia_async_uz7y856qzs popover=true popoverAnimateThumbnail=true'}],
		songs: [{name:`Dimitri Vegas & Like Mike vs Fedde Le Grand - Tales Of Tomorrow (feat. Julian Perretta)`,audio:tomorrowland_song}],
	},
	{
		id: 310,
		name: 'Akon: All My Life',
		info: ['Akon song placement','APG'],
		thumbnail: akon,
		thumbPos: {t:-0,l:0,size:1.54},
		brands: ['apg'],
		videos: [],
		songs: [{name:'Akon: All my life',audio:allmylife}],
	},


	// {
	// 	id: 12,
	// 	name: 'Love',
	// 	info: ['Love','ITV',],
	// 	thumbnail: loveisland_pic,
	// 	brands: ['ITV','ITV2'],
	// 	songs: [{name:'cccc',audio:loveisland_song}],
	// },
	// {
	// 	id: 13,
	// 	name: 'Love',
	// 	info: ['Love','ITV',],
	// 	thumbnail: loveisland_pic,
	// 	brands: ['ITV','ITV2'],
	// 	songs: [{name:'cccc',audio:loveisland_song}],
	// },
	// {
	// 	id: 14,
	// 	name: 'Love',
	// 	info: ['Love','ITV',],
	// 	thumbnail: loveisland_pic,
	// 	brands: ['ITV','ITV2'],
	// 	songs: [{name:'cccc',audio:loveisland_song}],
	// },
	// {
	// 	id: 15,
	// 	name: 'Love',
	// 	info: ['Love','ITV',],
	// 	thumbnail: loveisland_pic,
	// 	brands: ['ITV','ITV2'],
	// 	songs: [{name:'cccc',audio:loveisland_song}],
	// },


];

export default PlacementData;